import React from 'react';
import './Profile.css';

const Profile = () => {
  return (
    <div className='profile_container'>
      <h1>Profile</h1>
      <p>Manage your personal information and settings here.</p>
    </div>
  );
};

export default Profile;
